(function () {
  'use strict';

  var configSelector = 'script[data-vmax-binderpos-events]';
  var buttonSelector = [
    '.calendar-icon-info-action',
    '.calendar-list-event__buy-tickets-text.nonTicketed',
    '.calendar-board-event__buy-tickets-text.nonTicketed'
  ].join(', ');
  var sourceLabels = ['More info', 'View Information'];
  var observedAttribute = 'data-vmax-binderpos-events-ready';
  var scopeObservedAttribute = 'data-vmax-binderpos-events-scope-ready';

  function isSourceLabel(value) {
    return sourceLabels.indexOf(value.trim()) !== -1;
  }

  function replaceButtonLabel(button, label) {
    var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
    var textNode = walker.nextNode();

    while (textNode) {
      if (isSourceLabel(textNode.nodeValue)) {
        textNode.nodeValue = label;
        return;
      }

      textNode = walker.nextNode();
    }

    if (isSourceLabel(button.textContent)) button.textContent = label;
  }

  function translateButtons(scope, label) {
    if (scope.nodeType !== 1 && scope.nodeType !== 9) return;

    if (scope.matches && scope.matches(buttonSelector)) {
      replaceButtonLabel(scope, label);
    }

    scope.querySelectorAll(buttonSelector).forEach(function (button) {
      replaceButtonLabel(button, label);
    });
  }

  function initialize(config) {
    var section = config.closest('.shopify-section') || document;
    var calendar = section.querySelector('#binderpos-calendar');
    var translationScope = section.closest('main') || section;
    var label = config.getAttribute('data-more-info-label');

    if (!calendar || !label || calendar.hasAttribute(observedAttribute)) return;

    calendar.setAttribute(observedAttribute, 'true');
    translateButtons(translationScope, label);

    if (
      typeof MutationObserver === 'undefined' ||
      translationScope.hasAttribute(scopeObservedAttribute)
    ) return;

    translationScope.setAttribute(scopeObservedAttribute, 'true');

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          translateButtons(node, label);
        });
      });
    }).observe(translationScope, { childList: true, subtree: true });
  }

  function initializeWithin(scope) {
    if (scope.matches && scope.matches(configSelector)) initialize(scope);

    scope.querySelectorAll(configSelector).forEach(function (config) {
      initialize(config);
    });
  }

  initializeWithin(document);

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
})();
